import { RouteName } from "../../route";

export const LandingLanguage = {
    en: {
        navbar: {
            1: "Who We Are",
            2: "Our Impact",
            2.1: "Capital Investment",
            2.2: "EPC",
            2.3: "Renewable Energy",
            2.4: "Industrial",
            2.5: "Integrated Telecomunication",
            2.6: "Real Estate & Propertity",
            2.7: "Developer",
            2.8: "Research and Development",
            "2.9": "Business Compliance and Legal Advisory",
            "2.2.1": "Asset Management",
            "2.2.2": "Supply Chain",
            3: "Business Highlights",
            4: "Sustainability",
            4.1: "Commitment",
            4.2: "Our Strategic at QTC",
            4.3: "Partnerships",
            5: "Media",
            5.1: "Press Release",
            5.2: "Marketing Assets",
            6: "Contact",
            7: "Career",
            7.1: "Career Oportunities",
            7.2: "Why Join Us",
            7.3: "Explore Our Content Job",
        },
        [RouteName.main]: {
            1: "Quantum Trans Capital",
            2.1: "Sharing Investment Opportunities",
            2.2: "All Around Indonesia",
            3: "Who We Are",
            4.1: "Connecting Global Investors and Real Time",
            4.2: "Sustainable Projects in Indonesia",
            5.1: "A Resilient and Secure",
            5.2: "Holding Company with",
            5.3: "Diversified Energy Related",
            5.4: "Operating Assets",
            6: "Quantum Trans Capital, we drive positive change in Indonesia's economy by bridging visionary projects with strategic investors.",
            7: "Our focus on capital investment, renewable energy, real estate, and industrial needs fosters growth, innovation, and sustainability. As a catalyst for progress, Quantum Trans Capital connects opportunities and shapes a brighter future.",
            8: "Our Impact",
            9: "Quantum Trans Capital is an Indonesian company specializing in facilitating and funding investment opportunities across diverse sectors",
            10: "Business Highlights",
            11: "Quantum Trans Capital has brought leading projects, destinations and untapped opportunities to market through key partnerships and investments in the region and beyond",
            12: "Renewable Energy",
            13: "Sustainability",
            14: "<b>Quantum Trans Capital,</b> sustainability is a fundamental principle underlying our strategic direction and operational excellence.",
            15: "We are committed to delivering sustainable value for our stakeholders, while improving the performance of each line company.",
            16: "Our business is guided by sustainability principles that shape our strategic direction and operational excellence.",
            17: "Sustainability",
            18: "Keep track of all the exciting news and opportunities as wegrow our network by entering new markets, forging new partnerships, and our latest resources",
            19: "Explore our media centre",
            20: "Press releases and resources",
        },
        [RouteName.about]: {
            1.1: "Connect evolving needs with",
            1.2: "sustainable innovation opportunities",
            2: "Who we are",
            3.1: "Investing for Sustainable",
            3.2: "Growth in Indonesia",
            4: "Quantum Trans Capital is a dynamic and versatile global company that specializes in bridging and funding investment opportunities across multiple sectors.",
            5: "Quantum Trans Capital is also a PMA from Hong Kong.",
            6: "Our mission is to facilitate growth, innovation and sustainable development by connecting investors, entrepreneurs and projects.",
            7: "With a focus on capital, renewable energy, real estate, and other industrial needs, Quantum Trans Capital plays an important role in shaping the global economic landscape.",
            8: "Our Vision",
            9: "Quantum Trans Capital envisions a prosperous Indonesia where sustainable investments drive economic growth, improve livelihoods, and protect the environment.",
            10: "We strive to be a catalyst for positive change, fostering innovation and resilience.",
            11: "Our Mission",
            12: "Quantum Trans Capital is committed to transforming Indonesia's economic landscape through strategic, high-impact investments.",
            13: "Our mission is to bridge the gap between visionary projects and strategic investors, fostering sustainable growth, financial innovation, and long-term value creation. Leveraging our expertise in capital markets, asset management, and sector-focused financing within renewable energy, real estate, and industrial development, we are dedicated to delivering measurable returns while ensuring responsible growth.",
            14: "Quantum Trans Capital stands as a catalyst for progress, connecting opportunities and shaping a brighter future.",
            15: "Quantum Trans Capital Leadership",
            16: "Our people are our",
            17: "greatest strength",
            18: "Quantum Trans Capital focuses on building a global ecosystem that drives growth, technology and innovation opportunities for shareholders, companies and countries.",
        },
        [RouteName.ourImpact]: {
            1.1: "Driving Sustainable Innovation:",
            1.2: "Quantum Trans Capital's Impact",
            2: "Our Impact",
            3: "Through the management of a diversified and strategically integrated asset portfolio, Quantum Trans Capital is dedicated to fostering sustainable economic growth and advancing innovation across key industrial sectors. Guided by a disciplined investment strategy with a strong emphasis on ESG principles, we focus on creating long-term value for stakeholders while generating meaningful societal and environmental benefits.",
            4: "The companies within Quantum Trans Capital's portfolio represent industry leaders recognized for their bold, innovative approaches. Committed to advancing technological capabilities and implementing best practices, they drive positive, far-reaching impacts across diverse sectors. By prioritizing strategic partnerships and sustainability, Quantum Trans Capital consistently seeks solutions to address modern market challenges, contributing tangibly to inclusive and sustainable economic growth.",
        },
        [RouteName.capitalInvestment]: {
            1: "Capital Investment",
            2: "Quantum Trans Capital’s Capital Investment business line focuses on creating significant value through strategic equity placements and dedicated asset management solutions. We partner with organizations and shareholders to drive growth and stability, offering access to tailored investment opportunities.",
            3: "Our team ensures that every equity placement aligns with our rigorous criteria for long-term viability and profitability, fostering sustainable value for our investors. Through expert asset management, QTC prioritizes balanced portfolios that generate strong returns while managing risk.",
        },
        [RouteName.epc]: {
            1: "EPC (Engineering, Procurement, and Construction)",
            2: "In the EPC sector, QTC provides seamless, integrated engineering, procurement, and construction services to take projects from concept to completion. Our experts oversee every phase, from detailed engineering design to sourcing high-quality materials and managing installation processes.",
            3: "By maintaining strict standards in safety, quality, and efficiency, we ensure that each project we undertake not only meets but exceeds industry standards. This all-encompassing approach allows our clients to benefit from streamlined processes, faster project timelines, and cost-effective outcomes.",
        },
        [RouteName.renewableEnergy]: {
            1: "Renewable Energy",
            2: "Committed to a sustainable future, QTC's Renewable Energy unit delivers innovative solutions that reduce environmental impact while enhancing energy efficiency. Specializing in solar panels, lithium battery storage systems, and LED lighting, our offerings cater to both commercial and residential clients aiming to adopt cleaner energy.",
            3: "By integrating advanced technology with green practices, QTC helps clients reduce carbon emissions and transition smoothly toward sustainable energy sources that lower operational costs and contribute positively to the environment.",
        },
        [RouteName.industrial]: {
            1: "Industrial",
            2: "QTC's Industrial Solutions division supports diverse sectors with cutting-edge manufacturing and production capabilities, helping businesses elevate efficiency and meet industry demands.",
            3: "We combine industry expertise with advanced technology to deliver robust industrial services tailored to the specific needs of our clients. By providing custom solutions, we enable partners to optimize productivity, enhance quality control, and streamline operations, resulting in maximized operational effectiveness and minimized costs.",
        },
        [RouteName.integratedTelecomunication]: {
            1: "Integrated Telecommunication",
            2: "Our Integrated Telecommunications segment focuses on empowering businesses and communities with reliable, high-speed internet and hotspot services, supported by innovative IoT solutions.",
            3: "With a comprehensive approach to connectivity, QTC helps organizations and individuals stay seamlessly connected in an increasingly digital world. We provide advanced telecommunications solutions that not only meet current demands but also pave the way for future digital transformations by enabling smart, connected environments.",
        },
        [RouteName.realEstateProperty]: {
            1: "Real Estate & Property",
            2: "Quantum Trans Capital's Real Estate & Property branch develops and manages high-quality commercial buildings and shophouses strategically located in thriving areas.",
            3: "With a commitment to sustainable and functional design, our properties are tailored to meet the diverse needs of modern businesses and entrepreneurs. Each development prioritizes accessibility, style, and durability, creating spaces that attract clients and elevate their business presence in the market.",
        },
        [RouteName.developer]: {
            1: "Developer",
            2: "As a trusted property developer, QTC focuses on creating residential communities and apartments that blend Contact contemporary design with essential comforts. Our developments are crafted with the needs of urban dwellers in mind, offering a range of modern amenities and accessible locations.",
            3: "We emphasize sustainability and community, ensuring that each property provides a lasting, high-quality living experience that meets the expectations of discerning residents and property investors alike.",
        },
        [RouteName.researchDevelopment]: {
            1: "Research & Development",
            2: "QTC's Research & Development arm is dedicated to driving innovation and growth across all our business lines. Our team focuses on sales strategies, market analysis, and business development initiatives that bring insight-driven solutions to the forefront.",
            3: "By identifying market trends and optimizing operations, we help QTC stay at the cutting edge of each industry we Contact Career operate in. The R&D team continually explores new avenues to enhance customer experience, expand market reach, and bolster our competitive advantage.",
        },
        [RouteName.legal]: {
            1: "Business Compliance and Legal Advisory",
            2: "We provide expert legal guidance and ensure full compliance with regulations, helping businesses navigate complex legal landscapes. Our services include risk management, regulatory compliance, contract review, and assistance with permits, ensuring that companies operate smoothly and in accordance with all legal requirements.",
        },
        [RouteName.assetManagement]: {
            1: "Asset Management",
            2: "Our expert asset management services ensure that investments and assets are effectively managed to maximize value, optimize returns, and support long-term growth and sustainability.",
        },
        [RouteName.supplyChain]: {
            1: "Supply Chain",
            2: "Quantum Trans Capital enhances global supply chains by providing funding, managing risks, and supporting infrastructure development. It connects investors with supply chain projects, fostering efficiency and innovation across sectors like renewable energy, real estate, and manufacturing.",
        },
        [RouteName.businessHightlights]: {
            1.1: "Connect evolving needs with",
            1.2: "sustainable innovation opportunities",
            2: "Business Highlights",
            3: "Quantum Trans Capital continues to support the latest renewable energy-based developments",
            4: "Across the various sectors we operate and enable, we strive to deliver excellence and long-term sustainable value as we strengthen Quantum Trans Capital's position as a leading regional and international economic, commercial and renewable energy hub.",
            5: "We embrace innovative projects and work closely with strategic partners to enrich the lives of people, communities as a whole for a better tomorrow.",
            6: "Over the years, we have delivered leading projects and destinations as well as untapped opportunities through key partnerships and investments in the region and beyond. Here we believe that what we are doing is an innovation of sustainability and an excellent contribution to the sustainability of the Republic of Indonesia.",
            7: "Delivering sustainable value across various sectors",
        },
        [RouteName.sustainability]: {
            1.1: "Commitment, Strategy, and",
            1.2: "Partnerships for Sustainable Success",
            2: "Sustainability in Action",
            3: "Quantum Trans Capital is committed to driving long-term success by integrating sustainability principles across all aspects of its operations. With a strategy focused on innovation and efficiency, the company prioritizes the use of cutting-edge technology and responsible resource management.",
            4: "Through strong partnerships and synergy with key stakeholders, Quantum Trans Capital aims to create a lasting positive impact, foster inclusive economic growth, and contribute to the development of environmentally and socially responsible sectors. With a forward-looking approach to sustainability, Quantum Trans Capital is well-positioned to tackle future challenges and deliver value for all involved.",
        },
        [RouteName.sustainabilityCommitment]: {
            1: "Quantum Trans Capital",
            2: "Commitment",
            3: "As a holding investment company, we aim to connect investors, entrepreneurs, and innovative projects to foster growth and positively impact the Indonesian economy.",
            4: "Sustainability guides our operations, ensuring our practices are efficient, environmentally responsible, and socially conscious. We focus on renewable energy and sustainable real estate to build a better future. We prioritize sustainable value for all stakeholders, enhancing performance within our group to benefit everyone involved. Diversifying the economy is key to strengthening Indonesia’s resilience and global competitiveness.",
            5: "Leading with ethics and transparency, we foster trustworthy partnerships. We are also committed to empowering local communities through inclusive economic growth and impactful investments.",
            6: "Through these efforts, Quantum Trans Capital strives to be a leader in creating a sustainable and innovative investment ecosystem in Indonesia.",
        },
        [RouteName.sustainabilityStrategic]: {
            1: "Quantum Trans Capital",
            2: "Our Strategic at QTC",
            3: "Sustainable Investment: Diversification, ESG, Innovation & Positive Impact",
            4: "We are committed to becoming a leader in sustainable investment through a diversified portfolio in English sectors like renewable energy, real estate, technology, and manufacturing to minimize risk and maximize growth.",
            5: "Building strong partnerships with local, international investors and emphasizing socially and environmentally responsible investments are our top priorities. We integrate ESG criteria into every decision.",
            6: "Innovation and technology are key to our strategy, as we support startups tackling significant challenges.Market research informs our investment decisions.",
            7: "We empower entrepreneurs through capacity-building programs and engage with local communities for positive social impact. Our robust risk management and performance monitoring protect stakeholder interests.",
            8: "Through effective communication, we aim to strengthen our brand as a leader in sustainable investment, creating an innovative ecosystem that drives growth for all.",
        },
        [RouteName.sustainabilityPartnerships]: {
            1: "Quantum Trans Capital",
            2: "Partnerships",
            3: "Building Strong Partnerships for Sustainable Growth and Innovation",
            4: "Quantum Trans Capital views partnerships as a key element of our growth strategy. We are committed to building strong relationships with investors, entrepreneurs, and industry leaders, both locally and internationally.",
            5: "We believe that collaboration can drive innovation and create greater opportunities. By adhering to principles of ethics and transparency, we foster an environment of mutual respect.",
            6: "Through strategic partnerships, we integrate resources to develop projects that are financially beneficial and positively impacts society and the environment. Our main focus is on sustainable sectors like renewable energy.",
            7: "We also support the capacity development of our partners, providing access to opportunities and resources to strengthen their market position. In this way, Quantum Trans Capital aims to create a sustainable and innovative investment ecosystem for a more united future.",
        },
        [RouteName.media]: {
            1.1: "Quantum Trans Capital:",
            1.2: "News and Updates",
            2: "Press Release",
            3: "Find news by title",
            4: "Category",
            5: "Year",
            6: "Month",
            7: "Search News",
            8: "Next",
        },
        [RouteName.contact]: {
            1.1: "Connect with",
            1.2: "Quantum Trans Capital",
            2: "Contact Us :",
            3: "For inquiries or more information about our services and opportunities, please reach out via the contact form below or use the details provided.",
            4: "Our team is ready to assist you, and we look forward to connecting !",
            5: "GET IN TOUCH",
            6: "Head Office",
            7: "Connect with Us",
            8: "Here you can send us an inquiry concering general questions",
            9: "First Name",
            10: "Last Name",
            11: "Email Address",
            12: "Contact Number",
            13: "INQUIRY TYPE",
            14: "FILE ATTACHMENT",
            15: "Subject",
            16: "Message",
            17: "Upload File",
            18: "Submit",
        },
        [RouteName.career]: {
            1: "Career",
            2: "Career Opporturnies",
            3: "At Quantum Trans Capital , we believe that the success of our company starts with a strong and committed team. We strive to create a work environment that fosters professional development, innovation, and collaboration.",
            4: "As a growing holding company, we are always on the lookout for talented individuals who are passionate about contributing to our long-term value creation through sustainable investments and positive impact.",
            5: "Explore our current job opportunities",
        },
        [RouteName.careerExplore]: {
            1: "Career",
            2.1: "Explore our current",
            2.2: "job opportunities",
            3: "FIND JOBS",
            4: "Job title, skill, keyword",
            5: "NEAR LOCATION",
            6: "City, state, country",
            7: "ALL JOBS",
        },
        [RouteName.careerList]: {
            1: "Career",
            2: "Why Join Us ?",
            3.1: "Career Development :",
            3.2: "We support the growth and development of every individual through continuous training, mentoring, and long-term capacity-building opportunities.",
            4.1: "Collaborative Environment :",
            4.2: "At Quantum Trans Capital, we believe that teamwork is the foundation for achieving shared goals and creating innovative solutions.",
            5.1: "Social and Environmental Impact :",
            5.2: "We are committed to investing in sectors that are not only financially rewarding but also create a positive impact on society and the environment.",
            6.1: "Global Opportunities :",
            6.2: "As a holding company operating across multiple sectors and international markets, we offer opportunities for employees to work in diverse global environments.",
            7: "If you are passionate about contributing to a sustainable and innovative investment ecosystem, we invite you to explore our career opportunities and join our dynamic team.",
            8: "Explore our current job opportunities",
        },
    },
    id: {
        navbar: {
            1: "Siapa Kami",
            2: "Dampak Kami",
            2.1: "Investasi Modal",
            2.2: "EPC",
            2.3: "Energi Terbarukan",
            2.4: "Industri",
            2.5: "Telekomunikasi Terpadu",
            2.6: "Real Estat & Properti",
            2.7: "Pengembang",
            2.8: "Penelitian dan Pengembangan",
            "2.9": "Kepatuhan Bisnis dan Konsultasi Hukum",
            "2.2.1": "Manajemen Aset",
            "2.2.2": "Rantai Pasokan",
            3: "Sorotan Bisnis",
            4: "Keberlanjutan",
            4.1: "Komitmen",
            4.2: "Strategi Kami di QTC",
            4.3: "Kemitraan",
            5: "Media",
            5.1: "Siaran Pers",
            5.2: "Aset Pemasaran",
            6: "Kontak",
            7: "Karier",
            7.1: "Peluang Karier",
            7.2: "Mengapa Bergabung dengan Kami",
            7.3: "Jelajahi Pekerjaan Kami"
        },
        [RouteName.main]: {
            1: "Quantum Trans Capital",
            2.1: "Berbagi Peluang Investasi",
            2.2: "Di Seluruh Indonesia",
            3: "Tentang Kami",
            4.1: "Menghubungkan Investor Global dan",
            4.2: "Proyek Berkelanjutan Waktu Nyata di Indonesia",
            5.1: "Perusahaan Holding yang Tangguh dan Aman",
            5.2: "dengan",
            5.3: "Aset Operasional yang",
            5.4: "Berkaitan dengan Energi yang Beragam",
            6: "Quantum Trans Capital, kami mendorong perubahan positif dalam ekonomi Indonesia dengan menjembatani proyek-proyek visioner dengan investor strategis.",
            7: "Fokus kami pada investasi modal, energi terbarukan, real estat, dan kebutuhan industri mendorong pertumbuhan, inovasi, dan keberlanjutan. Sebagai katalisator kemajuan, Quantum Trans Capital menghubungkan peluang dan membentuk masa depan yang lebih cerah.",
            8: "Dampak Kami",
            9: "Quantum Trans Capital adalah perusahaan Indonesia yang mengkhususkan diri dalam memfasilitasi dan mendanai peluang investasi di berbagai sektor.",
            10: "Sorotan Bisnis",
            11: "Quantum Trans Capital telah membawa proyek-proyek unggulan, destinasi, dan peluang yang belum tergarap ke pasar melalui kemitraan dan investasi utama di wilayah ini dan sekitarnya.",
            12: "Energi Terbarukan",
            13: "Keberlanjutan",
            14: "<b>Quantum Trans Capital,</b> keberlanjutan adalah prinsip dasar yang mendasari arah strategis dan keunggulan operasional kami.",
            15: "Kami berkomitmen untuk memberikan nilai yang berkelanjutan bagi para pemangku kepentingan kami, sambil meningkatkan kinerja setiap lini perusahaan.",
            16: "Bisnis kami dipandu oleh prinsip keberlanjutan yang membentuk arah strategis dan keunggulan operasional kami.",
            17: "Keberlanjutan",
            18: "Ikuti semua berita menarik dan peluang saat kami memperluas jaringan, memasuki pasar baru, menjalin kemitraan baru, dan memanfaatkan sumber daya terbaru kami.",
            19: "Jelajahi pusat media kami",
            20: "Siaran pers dan sumber daya",
        },
        [RouteName.about]: {
            1.1: "Menghubungkan kebutuhan yang berkembang dengan",
            1.2: "peluang inovasi berkelanjutan",
            2: "Siapa kami",
            3.1: "Berinvestasi untuk Pertumbuhan Berkelanjutan",
            3.2: "di Indonesia",
            4: "Quantum Trans Capital adalah perusahaan global yang dinamis dan serbaguna yang mengkhususkan diri dalam menjembatani dan mendanai peluang investasi di berbagai sektor.",
            5: "Quantum Trans Capital juga merupakan PMA dari Hong Kong.",
            6: "Misi kami adalah untuk memfasilitasi pertumbuhan, inovasi, dan pembangunan berkelanjutan dengan menghubungkan investor, wirausahawan, dan proyek.",
            7: "Dengan fokus pada modal, energi terbarukan, properti, dan kebutuhan industri lainnya, Quantum Trans Capital memainkan peran penting dalam membentuk lanskap ekonomi global.",
            8: "Visi Kami",
            9: "Quantum Trans Capital membayangkan Indonesia yang makmur di mana investasi berkelanjutan mendorong pertumbuhan ekonomi, meningkatkan kesejahteraan, dan melindungi lingkungan.",
            10: "Kami berusaha menjadi katalis perubahan positif, mendorong inovasi dan ketahanan.",
            11: "Misi Kami",
            12: "Quantum Trans Capital berkomitmen untuk mengubah lanskap ekonomi Indonesia melalui investasi strategis yang berdampak tinggi.",
            13: "Misi kami adalah untuk menjembatani kesenjangan antara proyek visioner dan investor strategis, mendorong pertumbuhan berkelanjutan, inovasi finansial, dan penciptaan nilai jangka panjang. Memanfaatkan keahlian kami dalam pasar modal, manajemen aset, dan pembiayaan yang berfokus pada sektor energi terbarukan, properti, dan pengembangan industri, kami berdedikasi untuk memberikan hasil yang terukur sambil memastikan pertumbuhan yang bertanggung jawab.",
            14: "Quantum Trans Capital berdiri sebagai katalis untuk kemajuan, menghubungkan peluang dan membentuk masa depan yang lebih cerah.",
            15: "Kepemimpinan Quantum Trans Capital",
            16: "Orang-orang kami adalah",
            17: "kekuatan terbesar kami",
            18: "Quantum Trans Capital fokus untuk membangun ekosistem global yang mendorong pertumbuhan, teknologi, dan peluang inovasi bagi pemegang saham, perusahaan, dan negara.",
        },
        [RouteName.ourImpact]: {
            1.1: "Mendorong Inovasi Berkelanjutan:",
            1.2: "Dampak Quantum Trans Capital",
            2: "Dampak Kami",
            3: "Melalui pengelolaan portofolio aset yang terdiversifikasi dan terintegrasi secara strategis, Quantum Trans Capital berkomitmen untuk mendorong pertumbuhan ekonomi yang berkelanjutan dan memajukan inovasi di sektor industri utama. Dipandu oleh strategi investasi yang disiplin dengan penekanan kuat pada prinsip ESG, kami fokus pada penciptaan nilai jangka panjang bagi pemangku kepentingan sambil menghasilkan manfaat sosial dan lingkungan yang bermakna.",
            4: "Perusahaan-perusahaan dalam portofolio Quantum Trans Capital merupakan pemimpin industri yang diakui karena pendekatan inovatif dan berani mereka. Berkomitmen untuk memajukan kemampuan teknologi dan menerapkan praktik terbaik, mereka mendorong dampak positif yang luas di berbagai sektor. Dengan memprioritaskan kemitraan strategis dan keberlanjutan, Quantum Trans Capital secara konsisten mencari solusi untuk mengatasi tantangan pasar modern, memberikan kontribusi nyata terhadap pertumbuhan ekonomi yang inklusif dan berkelanjutan.",
        },
        [RouteName.capitalInvestment]: {
            1: "Investasi Modal",
            2: "Lini bisnis Investasi Modal Quantum Trans Capital fokus pada penciptaan nilai signifikan melalui penempatan ekuitas strategis dan solusi manajemen aset yang terdedikasi. Kami bermitra dengan organisasi dan pemegang saham untuk mendorong pertumbuhan dan stabilitas, menawarkan akses ke peluang investasi yang disesuaikan.",
            3: "Tim kami memastikan bahwa setiap penempatan ekuitas sesuai dengan kriteria ketat kami untuk kelayakan dan profitabilitas jangka panjang, mendorong nilai berkelanjutan bagi para investor kami. Melalui manajemen aset yang ahli, QTC memprioritaskan portofolio seimbang yang menghasilkan pengembalian yang kuat sambil mengelola risiko.",
        },
        [RouteName.epc]: {
            1: "EPC (Engineering, Procurement, and Construction)",
            2: "Di sektor EPC, QTC menyediakan layanan rekayasa, pengadaan, dan konstruksi terintegrasi yang mulus untuk membawa proyek dari konsep hingga selesai. Para ahli kami mengawasi setiap fase, dari desain rekayasa rinci hingga pengadaan material berkualitas tinggi dan mengelola proses instalasi.",
            3: "Dengan mempertahankan standar ketat dalam keselamatan, kualitas, dan efisiensi, kami memastikan bahwa setiap proyek yang kami jalankan tidak hanya memenuhi tetapi melebihi standar industri. Pendekatan menyeluruh ini memungkinkan klien kami untuk memperoleh manfaat dari proses yang lebih efisien, waktu proyek yang lebih cepat, dan hasil yang hemat biaya.",
        },
        [RouteName.renewableEnergy]: {
            1: "Energi Terbarukan",
            2: "Berkomitmen untuk masa depan yang berkelanjutan, unit Energi Terbarukan QTC menyediakan solusi inovatif yang mengurangi dampak lingkungan sambil meningkatkan efisiensi energi. Mengkhususkan diri dalam panel surya, sistem penyimpanan baterai litium, dan pencahayaan LED, penawaran kami melayani klien komersial dan residensial yang bertujuan mengadopsi energi yang lebih bersih.",
            3: "Dengan mengintegrasikan teknologi canggih dengan praktik ramah lingkungan, QTC membantu klien mengurangi emisi karbon dan beralih dengan lancar menuju sumber energi berkelanjutan yang menurunkan biaya operasional dan memberikan kontribusi positif terhadap lingkungan.",
        },
        [RouteName.industrial]: {
            1: "Industri",
            2: "Divisi Solusi Industri QTC mendukung berbagai sektor dengan kemampuan manufaktur dan produksi mutakhir, membantu bisnis meningkatkan efisiensi dan memenuhi tuntutan industri.",
            3: "Kami menggabungkan keahlian industri dengan teknologi canggih untuk memberikan layanan industri yang kuat yang disesuaikan dengan kebutuhan spesifik klien kami. Dengan menyediakan solusi khusus, kami memungkinkan mitra untuk mengoptimalkan produktivitas, meningkatkan pengendalian kualitas, dan menyederhanakan operasi, yang menghasilkan efektivitas operasional yang maksimal dan biaya yang diminimalkan.",
        },
        [RouteName.integratedTelecomunication]: {
            1: "Telekomunikasi Terintegrasi",
            2: "Segmen Telekomunikasi Terintegrasi kami fokus pada memberdayakan bisnis dan komunitas dengan layanan internet berkecepatan tinggi dan hotspot yang andal, didukung oleh solusi IoT yang inovatif.",
            3: "Dengan pendekatan komprehensif terhadap konektivitas, QTC membantu organisasi dan individu tetap terhubung tanpa hambatan di dunia yang semakin digital. Kami menyediakan solusi telekomunikasi canggih yang tidak hanya memenuhi tuntutan saat ini tetapi juga membuka jalan untuk transformasi digital di masa depan dengan memungkinkan lingkungan yang cerdas dan terhubung.",
        },
        [RouteName.realEstateProperty]: {
            1: "Properti & Real Estat",
            2: "Divisi Properti & Real Estat Quantum Trans Capital mengembangkan dan mengelola gedung komersial berkualitas tinggi dan rumah toko yang terletak strategis di daerah yang berkembang pesat.",
            3: "Dengan komitmen pada desain yang berkelanjutan dan fungsional, properti kami disesuaikan untuk memenuhi berbagai kebutuhan bisnis dan wirausahawan modern. Setiap pengembangan memprioritaskan aksesibilitas, gaya, dan daya tahan, menciptakan ruang yang menarik bagi klien dan meningkatkan kehadiran bisnis mereka di pasar.",
        },
        [RouteName.developer]: {
            1: "Pengembang",
            2: "Sebagai pengembang properti yang tepercaya, QTC fokus pada penciptaan komunitas perumahan dan apartemen yang memadukan desain kontemporer dengan kenyamanan yang esensial. Pengembangan kami dirancang dengan mempertimbangkan kebutuhan penghuni kota, menawarkan berbagai fasilitas modern dan lokasi yang mudah dijangkau.",
            3: "Kami menekankan keberlanjutan dan komunitas, memastikan bahwa setiap properti memberikan pengalaman hunian berkualitas tinggi yang tahan lama dan memenuhi harapan penghuni yang cermat serta investor properti.",
        },
        [RouteName.researchDevelopment]: {
            1: "Riset & Pengembangan",
            2: "Divisi Riset & Pengembangan QTC berkomitmen untuk mendorong inovasi dan pertumbuhan di semua lini bisnis kami. Tim kami fokus pada strategi penjualan, analisis pasar, dan inisiatif pengembangan bisnis yang membawa solusi berbasis wawasan ke garis depan.",
            3: "Dengan mengidentifikasi tren pasar dan mengoptimalkan operasi, kami membantu QTC tetap berada di garis depan setiap industri yang kami geluti. Tim R&D terus mengeksplorasi jalur baru untuk meningkatkan pengalaman pelanggan, memperluas jangkauan pasar, dan memperkuat keunggulan kompetitif kami.",
        },
        [RouteName.businessHightlights]: {
            1.1: "Menghubungkan kebutuhan yang berkembang dengan",
            1.2: "peluang inovasi berkelanjutan",
            2: "Sorotan Bisnis",
            3: "Quantum Trans Capital terus mendukung pengembangan berbasis energi terbarukan terbaru",
            4: "Di berbagai sektor yang kami jalankan dan fasilitasi, kami berusaha untuk memberikan keunggulan dan nilai berkelanjutan jangka panjang saat kami memperkuat posisi Quantum Trans Capital sebagai pusat ekonomi, komersial, dan energi terbarukan terkemuka di regional dan internasional.",
            5: "Kami merangkul proyek inovatif dan bekerja sama dengan mitra strategis untuk memperkaya kehidupan orang-orang dan komunitas secara keseluruhan demi masa depan yang lebih baik.",
            6: "Selama bertahun-tahun, kami telah menghasilkan proyek-proyek terkemuka dan destinasi serta peluang yang belum tergarap melalui kemitraan utama dan investasi di wilayah ini dan sekitarnya. Di sini kami percaya bahwa apa yang kami lakukan adalah inovasi keberlanjutan dan kontribusi luar biasa terhadap keberlanjutan Republik Indonesia.",
            7: "Menyampaikan nilai berkelanjutan di berbagai sektor",
        },
        [RouteName.sustainability]: {
            1.1: "Komitmen, Strategi, dan",
            1.2: "Kemitraan untuk Keberhasilan Berkelanjutan",
            2: "Keberlanjutan dalam Tindakan",
            3: "Quantum Trans Capital berkomitmen untuk mendorong kesuksesan jangka panjang dengan mengintegrasikan prinsip keberlanjutan ke dalam seluruh aspek operasinya. Dengan strategi yang berfokus pada inovasi dan efisiensi, perusahaan memprioritaskan penggunaan teknologi mutakhir dan pengelolaan sumber daya yang bertanggung jawab.",
            4: "Melalui kemitraan yang kuat dan sinergi dengan pemangku kepentingan utama, Quantum Trans Capital bertujuan untuk menciptakan dampak positif yang langgeng, mendorong pertumbuhan ekonomi inklusif, dan berkontribusi pada pengembangan sektor-sektor yang ramah lingkungan dan sosial. Dengan pendekatan yang berfokus pada masa depan, Quantum Trans Capital berada dalam posisi yang baik untuk menghadapi tantangan masa depan dan memberikan nilai bagi semua pihak yang terlibat.",
        },
        [RouteName.sustainabilityCommitment]: {
            1: "Quantum Trans Capital",
            2: "Komitmen",
            3: "Sebagai perusahaan investasi induk, kami bertujuan untuk menghubungkan investor, pengusaha, dan proyek-proyek inovatif untuk mendorong pertumbuhan dan memberikan dampak positif bagi perekonomian Indonesia.",
            4: "Keberlanjutan menjadi pedoman dalam operasi kami, memastikan bahwa praktik kami efisien, bertanggung jawab terhadap lingkungan, dan sadar sosial. Kami fokus pada energi terbarukan dan real estat berkelanjutan untuk membangun masa depan yang lebih baik. Kami memprioritaskan nilai berkelanjutan bagi semua pemangku kepentingan, meningkatkan kinerja dalam grup kami untuk memberikan manfaat bagi semua pihak yang terlibat. Diversifikasi ekonomi adalah kunci untuk memperkuat ketahanan Indonesia dan daya saing global.",
            5: "Dengan memimpin dengan etika dan transparansi, kami membangun kemitraan yang dapat dipercaya. Kami juga berkomitmen untuk memberdayakan komunitas lokal melalui pertumbuhan ekonomi yang inklusif dan investasi yang berdampak.",
            6: "Melalui upaya ini, Quantum Trans Capital berusaha untuk menjadi pemimpin dalam menciptakan ekosistem investasi yang berkelanjutan dan inovatif di Indonesia."
        },
        [RouteName.sustainabilityStrategic]: {
            1: "Quantum Trans Capital",
            2: "Strategi Kami di QTC",
            3: "Investasi Berkelanjutan: Diversifikasi, ESG, Inovasi & Dampak Positif",
            4: "Kami berkomitmen untuk menjadi pemimpin dalam investasi berkelanjutan melalui portofolio yang terdiversifikasi di sektor-sektor seperti energi terbarukan, real estat, teknologi, dan manufaktur untuk meminimalkan risiko dan memaksimalkan pertumbuhan.",
            5: "Membangun kemitraan yang kuat dengan investor lokal dan internasional serta menekankan investasi yang bertanggung jawab secara sosial dan lingkungan adalah prioritas utama kami. Kami mengintegrasikan kriteria ESG dalam setiap keputusan.",
            6: "Inovasi dan teknologi adalah kunci strategi kami, karena kami mendukung startup yang mengatasi tantangan besar. Riset pasar memberikan wawasan untuk pengambilan keputusan investasi kami.",
            7: "Kami memberdayakan pengusaha melalui program pembangunan kapasitas dan berinteraksi dengan komunitas lokal untuk dampak sosial yang positif. Manajemen risiko dan pemantauan kinerja yang kuat melindungi kepentingan pemangku kepentingan.",
            8: "Melalui komunikasi yang efektif, kami bertujuan untuk memperkuat merek kami sebagai pemimpin dalam investasi berkelanjutan, menciptakan ekosistem inovatif yang mendorong pertumbuhan untuk semua."
        },
        [RouteName.sustainabilityPartnerships]: {
            1: "Quantum Trans Capital",
            2: "Kemitraan",
            3: "Membangun Kemitraan yang Kuat untuk Pertumbuhan dan Inovasi Berkelanjutan",
            4: "Quantum Trans Capital melihat kemitraan sebagai elemen kunci dari strategi pertumbuhan kami. Kami berkomitmen untuk membangun hubungan yang kuat dengan investor, pengusaha, dan pemimpin industri, baik secara lokal maupun internasional.",
            5: "Kami percaya bahwa kolaborasi dapat mendorong inovasi dan menciptakan peluang yang lebih besar. Dengan mematuhi prinsip etika dan transparansi, kami menciptakan lingkungan yang saling menghormati.",
            6: "Melalui kemitraan strategis, kami mengintegrasikan sumber daya untuk mengembangkan proyek-proyek yang menguntungkan secara finansial dan memberikan dampak positif bagi masyarakat dan lingkungan. Fokus utama kami adalah pada sektor-sektor berkelanjutan seperti energi terbarukan.",
            7: "Kami juga mendukung pengembangan kapasitas mitra kami, memberikan akses ke peluang dan sumber daya untuk memperkuat posisi pasar mereka. Dengan cara ini, Quantum Trans Capital bertujuan untuk menciptakan ekosistem investasi yang berkelanjutan dan inovatif untuk masa depan yang lebih bersatu."
        },
        [RouteName.media]: {
            1.1: "Quantum Trans Capital:",
            1.2: "Berita dan Pembaruan",
            2: "Siaran Pers",
            3: "Temukan berita berdasarkan judul",
            4: "Kategori",
            5: "Tahun",
            6: "Bulan",
            7: "Cari Berita",
            8: "Selanjutnya"
        },
        [RouteName.contact]: {
            1.1: "Hubungi",
            1.2: "Quantum Trans Capital",
            2: "Kontak Kami:",
            3: "Untuk pertanyaan atau informasi lebih lanjut mengenai layanan dan peluang kami, silakan hubungi melalui formulir kontak di bawah ini atau gunakan detail yang disediakan.",
            4: "Tim kami siap membantu Anda, dan kami menantikan untuk dapat terhubung!",
            5: "HUBUNGI KAMI",
            6: "Kantor Pusat",
            7: "Hubungi Kami",
            8: "Di sini Anda dapat mengirimkan pertanyaan terkait pertanyaan umum",
            9: "Nama Depan",
            10: "Nama Belakang",
            11: "Alamat Email",
            12: "Nomor Kontak",
            13: "JENIS PERTANYAAN",
            14: "LAMPIRAN BERKAS",
            15: "Subjek",
            16: "Pesan",
            17: "Unggah Berkas",
            18: "Kirim"
        },
        [RouteName.career]: {
            1: "Karir",
            2: "Peluang Karir",
            3: "Di Quantum Trans Capital, kami percaya bahwa kesuksesan perusahaan kami dimulai dengan tim yang kuat dan berdedikasi. Kami berusaha menciptakan lingkungan kerja yang mendukung pengembangan profesional, inovasi, dan kolaborasi.",
            4: "Sebagai perusahaan induk yang berkembang, kami selalu mencari individu berbakat yang memiliki semangat untuk berkontribusi pada penciptaan nilai jangka panjang kami melalui investasi berkelanjutan dan dampak positif.",
            5: "Jelajahi peluang pekerjaan kami saat ini"
        },
        [RouteName.careerExplore]: {
            1: "Karir",
            2.1: "Jelajahi",
            2.2: "peluang pekerjaan kami saat ini",
            3: "CARI PEKERJAAN",
            4: "Judul pekerjaan, keterampilan, kata kunci",
            5: "LOKASI TERDEKAT",
            6: "Kota, provinsi, negara",
            7: "SEMUA PEKERJAAN"
        },
        [RouteName.careerList]: {
            1: "Karir",
            2: "Mengapa Bergabung dengan Kami?",
            3.1: "Pengembangan Karir:",
            3.2: "Kami mendukung pertumbuhan dan pengembangan setiap individu melalui pelatihan berkelanjutan, pembimbingan, dan peluang pembangunan kapasitas jangka panjang.",
            4.1: "Lingkungan Kolaboratif:",
            4.2: "Di Quantum Trans Capital, kami percaya bahwa kerja tim adalah dasar untuk mencapai tujuan bersama dan menciptakan solusi inovatif.",
            5.1: "Dampak Sosial dan Lingkungan:",
            5.2: "Kami berkomitmen untuk berinvestasi di sektor-sektor yang tidak hanya menguntungkan secara finansial, tetapi juga menciptakan dampak positif bagi masyarakat dan lingkungan.",
            6.1: "Peluang Global:",
            6.2: "Sebagai perusahaan induk yang beroperasi di berbagai sektor dan pasar internasional, kami menawarkan peluang bagi karyawan untuk bekerja di lingkungan global yang beragam.",
            7: "Jika Anda memiliki semangat untuk berkontribusi pada ekosistem investasi yang berkelanjutan dan inovatif, kami mengundang Anda untuk menjelajahi peluang karir kami dan bergabung dengan tim dinamis kami.",
            8: "Jelajahi peluang pekerjaan kami saat ini"
        },
    },
    zh: {
        navbar: {
            1: "关于我们",
            2: "我们的影响",
            2.1: "资本投资",
            2.2: "EPC",
            2.3: "可再生能源",
            2.4: "工业",
            2.5: "综合电信",
            2.6: "房地产与物业",
            2.7: "开发商",
            2.8: "研究与开发",
            "2.9": "商业合规与法律咨询",
            "2.2.1": "资产管理",
            "2.2.2": "供应链",
            3: "业务亮点",
            4: "可持续发展",
            4.1: "承诺",
            4.2: "我们的QTC战略",
            4.3: "合作伙伴",
            5: "媒体",
            5.1: "新闻发布",
            5.2: "市场营销资产",
            6: "联系我们",
            7: "职业生涯",
            7.1: "职业机会",
            7.2: "为什么加入我们",
            7.3: "探索我们的工作"
        },
        [RouteName.main]: {
            1: "Quantum Trans Capital",
            2.1: "共享投资机会",
            2.2: "遍布印度尼西亚",
            3: "关于我们",
            4.1: "连接全球投资者与",
            4.2: "印度尼西亚的实时可持续项目",
            5.1: "强大而安全的控股公司",
            5.2: "与",
            5.3: "多元化能源相关的",
            5.4: "运营资产",
            6: "Quantum Trans Capital 通过连接战略投资者与愿景项目，推动印度尼西亚经济的积极变革。",
            7: "我们专注于资本投资、可再生能源、房地产和工业需求，以促进增长、创新和可持续发展。作为变革的催化剂，Quantum Trans Capital 连接机遇并塑造更加光明的未来。",
            8: "我们的影响",
            9: "Quantum Trans Capital 是一家印度尼西亚公司，专注于在多个行业中促进和资助投资机会。",
            10: "业务亮点",
            11: "Quantum Trans Capital 通过主要投资和合作伙伴关系，将独特项目、目的地和未开发的机会带入市场。",
            12: "可再生能源",
            13: "可持续发展",
            14: "<b>Quantum Trans Capital,</b> 可持续发展是我们战略方向和运营卓越的核心原则。",
            15: "我们致力于为利益相关者创造可持续价值，同时提升公司各个业务领域的绩效。",
            16: "我们的业务受可持续发展原则的指导，塑造战略方向并提升运营效率。",
            17: "可持续发展",
            18: "关注最新动态和机会，我们不断扩展网络，进入新市场，建立新合作，并利用最新资源。",
            19: "探索我们的媒体中心",
            20: "新闻发布和资源",
        },
        [RouteName.about]: {
            1.1: "连接不断发展的需求与",
            1.2: "可持续创新机会",
            2: "关于我们",
            3.1: "投资可持续增长",
            3.2: "在印度尼西亚",
            4: "Quantum Trans Capital 是一家充满活力和多元化的全球公司，专注于连接和资助多个行业的投资机会。",
            5: "Quantum Trans Capital 也是一家来自香港的外商投资企业（PMA）。",
            6: "我们的使命是通过连接投资者、企业家和项目，促进增长、创新和可持续发展。",
            7: "Quantum Trans Capital 专注于资本、可再生能源、房地产及工业需求，在塑造全球经济格局方面发挥关键作用。",
            8: "我们的愿景",
            9: "Quantum Trans Capital 设想一个繁荣的印度尼西亚，在这里，可持续投资推动经济增长，提高福祉，并保护环境。",
            10: "我们致力于成为积极变革的催化剂，推动创新和可持续发展。",
            11: "我们的使命",
            12: "Quantum Trans Capital 致力于通过高影响力的战略投资，改变印度尼西亚的经济格局。",
            13: "我们的使命是弥合愿景项目与战略投资者之间的差距，推动可持续增长、金融创新和长期价值创造。凭借我们在资本市场、资产管理以及可再生能源、房地产和工业发展融资方面的专业知识，我们致力于在确保负责任增长的同时提供可衡量的成果。",
            14: "Quantum Trans Capital 作为变革的催化剂，连接机遇并塑造更光明的未来。",
            15: "Quantum Trans Capital 领导团队",
            16: "我们的团队是",
            17: "我们最强大的力量",
            18: "Quantum Trans Capital 专注于建立一个全球生态系统，以推动增长、技术进步和为股东、企业及国家创造创新机会。",
        },
        [RouteName.ourImpact]: {
            1.1: "推动可持续创新：",
            1.2: "Quantum Trans Capital 的影响",
            2: "我们的影响",
            3: "通过管理多元化且战略整合的资产投资组合，Quantum Trans Capital 致力于推动可持续的经济增长，并促进主要行业的创新。我们坚持严格的投资策略，强调 ESG 原则，专注于为利益相关者创造长期价值，同时带来显著的社会和环境效益。",
            4: "Quantum Trans Capital 投资组合中的公司是行业领先者，以其创新和大胆的战略而闻名。他们致力于提升技术能力并采用最佳实践，从而在多个行业产生深远的积极影响。通过优先考虑战略合作与可持续性，Quantum Trans Capital 持续探索解决现代市场挑战的方案，为包容性和可持续的经济增长做出实质性贡献。",
        },
        [RouteName.capitalInvestment]: {
            1: "资本投资",
            2: "Quantum Trans Capital 的资本投资业务专注于通过战略性股权投资和专业资产管理解决方案创造重要价值。我们与企业和股东合作，推动增长与稳定，并提供量身定制的投资机会。",
            3: "我们的团队确保每项股权投资都符合严格的可行性和长期盈利标准，为投资者创造可持续的价值。凭借专业的资产管理，QTC 优先打造平衡的投资组合，实现强劲回报的同时有效控制风险。",
        },
        [RouteName.epc]: {
            1: "EPC（工程、采购与施工）",
            2: "在 EPC 领域，QTC 提供无缝的工程、采购和施工一体化服务，确保项目从概念到完成顺利推进。我们的专家团队全程监督，包括详细的工程设计、高质量材料采购和安装管理。",
            3: "我们严格遵守安全、质量和效率标准，确保每个项目不仅符合行业标准，更能超越预期。综合方法使客户受益于更高效的流程、更快的项目交付周期以及更具成本效益的成果。",
        },
        [RouteName.renewableEnergy]: {
            1: "可再生能源",
            2: "QTC 可再生能源部门致力于提供创新解决方案，减少环境影响的同时提高能源效率。我们专注于太阳能电池板、锂电池储能系统和 LED 照明，为商业和住宅客户提供清洁能源选择。",
            3: "通过将先进技术与环保实践相结合，QTC 帮助客户减少碳排放，并顺利向可持续能源过渡，从而降低运营成本并对环境产生积极影响。",
        },
        [RouteName.industrial]: {
            1: "工业",
            2: "QTC 工业解决方案部门支持多个行业，通过先进的制造和生产能力，帮助企业提高效率并满足行业需求。",
            3: "我们结合行业专业知识与先进技术，提供针对客户特定需求的高效工业服务。定制化解决方案帮助合作伙伴优化生产力、提升质量控制、简化运营，实现最高效能并降低成本。",
        },
        [RouteName.integratedTelecomunication]: {
            1: "综合电信",
            2: "我们的综合电信部门致力于为企业和社区提供高速互联网和可靠的热点服务，并结合创新的物联网解决方案。",
            3: "QTC 采用全面的连接方式，确保企业和个人在日益数字化的世界中保持无缝连接。我们提供先进的电信解决方案，不仅满足当前需求，还为未来的数字化转型奠定基础，推动智能互联环境的发展。",
        },
        [RouteName.realEstateProperty]: {
            1: "房地产与物业",
            2: "Quantum Trans Capital 的房地产与物业部门专注于开发和管理优质商业建筑及战略性区域的商铺。",
            3: "我们致力于可持续且功能性的设计，打造适合现代企业家和商业需求的物业。每个项目都优先考虑可达性、风格和耐用性，为客户创造吸引人的空间，并提升其市场竞争力。",
        },
        [RouteName.developer]: {
            1: "开发商",
            2: "作为值得信赖的房地产开发商，QTC 重点打造集现代设计与核心便利设施于一体的住宅和公寓社区。我们针对城市居民的需求，提供多种现代化设施，并选择便捷的地理位置。",
            3: "我们强调可持续性与社区建设，确保每个物业都能提供高质量的居住体验，并符合精明购房者与投资者的期望。",
        },
        [RouteName.researchDevelopment]: {
            1: "研发（研究与开发）",
            2: "QTC 研发部门致力于推动创新和增长，涵盖所有业务领域。我们的团队专注于销售策略、市场分析和业务发展计划，以数据驱动的方式提供解决方案。",
            3: "通过识别市场趋势并优化运营，我们帮助 QTC 在各行业保持领先地位。研发团队不断探索新途径，以提升客户体验、拓展市场覆盖范围，并巩固我们的竞争优势。",
        },
        [RouteName.businessHightlights]: {
            1.1: "连接不断变化的需求与",
            1.2: "可持续创新机遇",
            2: "业务亮点",
            3: "Quantum Trans Capital 持续推动最新的可再生能源发展",
            4: "在我们运营和推动的各个行业中，我们始终追求卓越和长期可持续价值，同时巩固 Quantum Trans Capital 作为区域和国际经济、商业及可再生能源枢纽的地位。",
            5: "我们拥抱创新项目，并与战略合作伙伴携手合作，以改善人们的生活和整个社区，为更美好的未来做出贡献。",
            6: "多年来，我们通过关键合作伙伴关系和投资，在本地区及周边创造了领先项目、重要目的地和未开发的商业机会。我们坚信，我们所做的每一件事都是可持续创新，并为印度尼西亚的可持续发展做出了卓越贡献。",
            7: "在多个行业创造可持续价值",
        },
        [RouteName.sustainability]: {
            1.1: "承诺、战略与",
            1.2: "可持续成功的合作伙伴关系",
            2: "可持续行动",
            3: "Quantum Trans Capital 致力于推动长期成功，将可持续发展原则融入运营的每个环节。我们采用以创新和效率为核心的战略，优先使用先进技术，并负责任地管理资源。",
            4: "通过与主要利益相关者的强大合作关系和协同效应，Quantum Trans Capital 旨在创造持久的积极影响，推动包容性经济增长，并促进环保和社会友好型行业的发展。凭借前瞻性思维，Quantum Trans Capital 处于迎接未来挑战的有利位置，并为所有相关方提供可持续价值。",
        },
        [RouteName.sustainabilityCommitment]: {
            1: "Quantum Trans Capital",
            2: "承诺",
            3: "作为一家投资控股公司，我们的目标是连接投资者、企业家和创新项目，以推动增长并为印度尼西亚经济带来积极影响。",
            4: "可持续性是我们运营的指导原则，确保我们的实践高效、环境责任强，并具有社会意识。我们专注于可再生能源和可持续房地产，以构建更美好的未来。我们优先考虑所有利益相关者的可持续价值，提升我们集团的绩效，为所有相关方带来收益。经济多元化是增强印度尼西亚韧性和全球竞争力的关键。",
            5: "通过秉持道德和透明度，我们建立值得信赖的合作伙伴关系。同时，我们致力于通过包容性经济增长和有影响力的投资来赋能当地社区。",
            6: "通过这些努力，Quantum Trans Capital 力求成为印度尼西亚可持续和创新投资生态系统的领导者。"
        },
        [RouteName.sustainabilityStrategic]: {
            1: "Quantum Trans Capital",
            2: "我们的战略",
            3: "可持续投资：多元化、ESG、创新与积极影响",
            4: "我们致力于通过在可再生能源、房地产、科技和制造业等行业的多元化投资组合，成为可持续投资的领导者，以降低风险并最大化增长。",
            5: "建立与本地及国际投资者的牢固合作关系，并强调社会和环境责任投资，是我们的首要任务。我们在每项决策中整合 ESG 标准。",
            6: "创新和技术是我们战略的关键，我们支持解决重大挑战的初创企业。市场研究为我们的投资决策提供洞察。",
            7: "我们通过能力建设计划赋能企业家，并与当地社区互动，以实现积极的社会影响。强有力的风险管理和绩效监测保障利益相关者的权益。",
            8: "通过有效沟通，我们致力于强化品牌形象，成为可持续投资的领导者，打造促进所有人增长的创新生态系统。"
        },
        [RouteName.sustainabilityPartnerships]: {
            1: "Quantum Trans Capital",
            2: "合作伙伴关系",
            3: "建立强大合作伙伴关系，实现可持续增长与创新",
            4: "Quantum Trans Capital 视合作伙伴关系为我们增长战略的关键要素。我们致力于与本地及国际投资者、企业家和行业领袖建立牢固的关系。",
            5: "我们相信，协作可以推动创新并创造更大的机遇。通过遵循道德和透明原则，我们营造相互尊重的环境。",
            6: "通过战略合作，我们整合资源，以开发在经济上有利可图且对社会和环境有积极影响的项目。我们的重点行业是可持续领域，如可再生能源。",
            7: "我们还支持合作伙伴的能力发展，为他们提供机会和资源，以增强市场竞争力。通过这种方式，Quantum Trans Capital 旨在为未来打造一个可持续和创新的投资生态系统。"
        },
        [RouteName.media]: {
            1.1: "Quantum Trans Capital:",
            1.2: "新闻与更新",
            2: "新闻发布",
            3: "按标题查找新闻",
            4: "类别",
            5: "年份",
            6: "月份",
            7: "搜索新闻",
            8: "下一步"
        },
        [RouteName.contact]: {
            1.1: "联系我们",
            1.2: "Quantum Trans Capital",
            2: "联系我们：",
            3: "如有任何问题或需要了解更多关于我们的服务和机会的信息，请填写下方联系表，或使用提供的联系方式与我们联系。",
            4: "我们的团队随时为您提供帮助，期待与您交流！",
            5: "联系我们",
            6: "总部",
            7: "联系我们",
            8: "在这里，您可以提交有关常见问题的咨询",
            9: "名字",
            10: "姓氏",
            11: "电子邮件地址",
            12: "联系电话",
            13: "问题类型",
            14: "附件",
            15: "主题",
            16: "留言",
            17: "上传文件",
            18: "提交"
        },
        [RouteName.career]: {
            1: "职业发展",
            2: "职业机会",
            3: "在 Quantum Trans Capital，我们相信公司的成功始于一支强大而敬业的团队。我们致力于创造一个支持职业发展、创新和协作的工作环境。",
            4: "作为一家不断发展的控股公司，我们始终在寻找富有才华的人才，他们有激情通过可持续投资和积极影响来为我们的长期价值创造做出贡献。",
            5: "探索我们当前的职位机会"
        },
        [RouteName.careerExplore]: {
            1: "职业发展",
            2.1: "探索",
            2.2: "我们当前的职位机会",
            3: "搜索职位",
            4: "职位名称、技能、关键词",
            5: "最近的地点",
            6: "城市、省份、国家",
            7: "所有职位"
        },
        [RouteName.careerList]: {
            1: "职业发展",
            2: "为什么加入我们？",
            3.1: "职业发展：",
            3.2: "我们通过持续培训、辅导和长期能力建设机会，支持每个人的成长和发展。",
            4.1: "协作环境：",
            4.2: "在 Quantum Trans Capital，我们相信团队合作是实现共同目标并创造创新解决方案的基础。",
            5.1: "社会与环境影响：",
            5.2: "我们致力于投资于不仅在经济上有利可图，同时也能对社会和环境产生积极影响的行业。",
            6.1: "全球机遇：",
            6.2: "作为一家在多个行业和国际市场运营的控股公司，我们为员工提供在多元化全球环境中工作的机会。",
            7: "如果您对为可持续和创新的投资生态系统做出贡献充满热情，我们邀请您探索我们的职业机会，并加入我们充满活力的团队。",
            8: "探索我们当前的职位机会"
        }
    },
}